<template>
  <div class="d-flex justify-content-between w-100">
    <div class="column features w-25">
      <div>&nbsp;</div>
      <div class="bg-nu">Extra Transaction Fees</div>
      <div>Customizable Design</div>
      <div class="bg-nu">Unlimited Business Email</div>
      <div>24/7/365 Support</div>
    </div>
    <div class="d-flex justify-content-between w-75">
      <div class="column shadow">
        <div>
          <div><Logo logo="nexcess" :size="70" /></div>
        </div>
        <div><div>No Fees</div></div>
        <div><div>Unlimited</div></div>
        <div><div>Yes</div></div>
        <div><div>Yes</div></div>
      </div>
      <div class="column">
        <div>
          <div><Logo class="godaddy-logo" logo="godaddy" :size="100" /></div>
        </div>
        <div class="bg-nu"><div>Has Fees</div></div>
        <div><div>Limited</div></div>
        <div class="bg-nu"><div>No</div></div>
        <div><div>Limited</div></div>
      </div>
      <div class="column">
        <div>
          <div><Logo logo="shopify" :size="70" /></div>
        </div>
        <div class="bg-nu"><div>Has Fees</div></div>
        <div><div>Limited</div></div>
        <div class="bg-nu"><div>No</div></div>
        <div><div>Limited</div></div>
      </div>
      <div class="column">
        <div>
          <div><Logo logo="squarespace" :size="70" /></div>
        </div>
        <div class="bg-nu"><div>Has Fees</div></div>
        <div><div>Limited</div></div>
        <div class="bg-nu"><div>No</div></div>
        <div><div>Limited</div></div>
      </div>
      <div class="column">
        <div>
          <div><Logo class="wix-logo" logo="wix" :size="70" /></div>
        </div>
        <div class="bg-nu"><div>Has Fees</div></div>
        <div><div>Limited</div></div>
        <div class="bg-nu"><div>No</div></div>
        <div><div>Limited</div></div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/display/Logo";

export default {
  name: "BrandComparisonTable",
  components: {
    Logo,
  },
};
</script>

<style lang="scss" scoped>
.column {
  height: 14rem;
  width: 100%;
  height: 24rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.column > div {
  height: 100%;
}

.column:not(:first-child) > div,
.column:nth-child(1) > div {
  display: flex;
}

.column > div > div {
  margin: auto;
}

.godaddy-logo {
  max-height: 2rem;
}

.wix-logo {
  max-height: 3rem;
}

.column.features > div {
  text-align: left;
  font-weight: bold;
  padding: 0.75rem;
}

.column:nth-child(1) > div:not(:first-child) > div {
  background-color: #f46728;
  border: none;
  color: white;
  padding: 0.2rem 0.75rem;
  text-decoration: none;
  display: inline-block;
  border-radius: 14px;
  font-weight: bold;
  margin: auto;
}
</style>
